<template>
  <div class="card-body mt-4">
    <div class="table-responsive">
      <h4>Order Data Performance</h4>
      <table class="table">
        <thead class="table-light">
        <tr>
          <th>Period</th>
          <th>Gross Total</th>
          <th>Net Total</th>
          <th>Qty</th>
          <th>Orders</th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in tableData" :key="index">
        <tr>
          <td>{{item.period}}</td>
          <td>Ksh {{item.period_gross_total | formatNumber}}</td>
          <td>Ksh {{item.period_net_total | formatNumber}}</td>
          <td> {{item.period_item_units | formatNumber}}</td>
          <td>
          {{item.period_orders | formatNumber}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleOrderPerformanceTable",
  props: {
    tableData: {
      type: Array,
      default (){
        return {
          categories: [],
          data: []
        }
      }
    },
  },
  methods: {
    setOrders(orders){
      this.$emit('setOrders', orders)
    }
  }
}
</script>

<style scoped>

</style>
